import { render, staticRenderFns } from "./VProcess.vue?vue&type=template&id=08c27038&"
import script from "./VProcess.vue?vue&type=script&lang=js&"
export * from "./VProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports